import fetch from "@lib/fetch";
import { API } from "../../config";
import {isAuthenticated} from "./auth";

const createFilter = (name,nf) => {
    const data = {    
        name:name,
        confirmed_start_date:nf.confirmedStartDate,
        confirmed_end_date:nf.confirmedEndDate,
        created_start_date:nf.createdStartDate,
        created_end_date:nf.createdEndDate,
        courier_codes:nf.couriers,
        courier_services:null,
        status:nf.status,
        tags:nf.tags
    }

    return fetch(`${API}/v1/filters`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${isAuthenticated().token}`
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};

const createFilterAdmin = (name,nf,userId) => {
    const data = {    
        name:name,
        confirmed_start_date:nf.confirmedStartDate,
        confirmed_end_date:nf.confirmedEndDate,
        created_start_date:nf.createdStartDate,
        created_end_date:nf.createdEndDate,
        courier_codes:nf.couriers,
        courier_services:null,
        status:nf.status,
        tags:nf.tags
    }

    return fetch(`${API}/v1/admin/filters/users/${userId}`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${isAuthenticated().token}`
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};

const search = (value) => {
    return fetch(`${API}/v1/search/filters`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${isAuthenticated().token}`
        },
        body: JSON.stringify({value})
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};

const searchAdmin = (value,userId) => {
    return fetch(`${API}/v1/admin/search/filters/users/${userId}`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${isAuthenticated().token}`
        },
        body: JSON.stringify({value})
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};

export default {
    createFilter,
    createFilterAdmin,
    search,
    searchAdmin
}